import React, { Component } from 'react';
import {
    Form, Input, Button, Select,
} from 'antd';

const Option = Select.Option;

function handleChange(value) {
    console.log(`selected ${value}`);
}

function handleBlur() {
    console.log('blur');
}

function handleFocus() {
    console.log('focus');
}


class AdminCompaniesAddView extends Component {
    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit(event) {
        event.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.props.handleSubmit(values);
            }
        });
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        return (
            <div>
                <Form onSubmit={this.handleSubmit}>
                    <Form.Item>
                        {getFieldDecorator('name', {
                            rules: [{ required: true, message: 'Ingrese el nombre de la empresa!' }],
                        })(
                            <Input placeholder="Nombre Empresa" />,
                        )}
                    </Form.Item>
                    <Form.Item>
                        {getFieldDecorator('email', {
                            rules: [{ required: true, message: 'Ingrese correo de la empresa!' }],
                        })(
                            <Input placeholder="Correo electrónico" />,
                        )}
                    </Form.Item>
                    <Form.Item>
                        {getFieldDecorator('address', {
                            rules: [{ required: true, message: 'Ingrese la dirección!' }],
                        })(
                            <Input placeholder="Dirección" />,
                        )}
                    </Form.Item>
                    <Form.Item>
                        {getFieldDecorator('nit', {
                            rules: [{ required: true, message: 'Ingrese el número de NIT' }],
                        })(
                            <Input type="number" placeholder="Número de NIT" />,
                        )}
                    </Form.Item>
                    <Form.Item>
                        {getFieldDecorator('phone', {
                            rules: [{ required: true, message: 'Ingrese el número de Teléfono' }],
                        })(
                            <Input type="number" placeholder="Número de Teléfono" />,
                        )}
                    </Form.Item>

                    <Form.Item>
                        {getFieldDecorator('status', {
                            rules: [{ required: true, message: 'Ingrese el status!' }],
                        })(
                            <Select
                                showSearch
                                style={{ width: 200 }}
                                placeholder="Selecciona el Status"
                                optionFilterProp="children"
                                onChange={handleChange}
                                onFocus={handleFocus}
                                onBlur={handleBlur}
                                filterOption={(input, option) => option.props.children.toLowerCase()
                                    .indexOf(input.toLowerCase()) >= 0}
                            >
                                <Option value="active">
                                    Activo
                                </Option>
                                <Option value="inactive">
                                    Inactivo
                                </Option>
                            </Select>,
                        )}

                    </Form.Item>

                    <Form.Item>
                        <Button type="primary" htmlType="submit">
                            Guardar
                        </Button>
                    </Form.Item>
                </Form>
            </div>
        );
    }
}

export default Form.create()(AdminCompaniesAddView);



// WEBPACK FOOTER //
// ./src/components/views/AdminCompaniesAddView.js